<template>
    <div class="landing-page home wefix">

    </div>
</template>

<script>
    export default {
        beforeCreate: function() {
            this.$router.push({name: 'postcodeSearch'})
        }
    }
</script>

<style>

</style>